<template>
  <div class="caixa-dropdown" @click.stop>
    <!-- Cabeçalho do dropdown ─────────────────────────────────────────── -->
    <header class="caixa-dropdown__header">
      <div class="caixa-dropdown__title">
        <i class="fas fa-cash-register"></i>
        <span>Caixa</span>
        <span
          class="caixa-dropdown__badge"
          :class="caixaAberto ? 'caixa-dropdown__badge--aberto' : 'caixa-dropdown__badge--fechado'"
        >
          {{ caixaAberto ? 'Aberto' : 'Fechado' }}
        </span>
      </div>
      <button class="caixa-dropdown__close" title="Fechar" @click="$emit('fechar')">
        <i class="fas fa-times"></i>
      </button>
    </header>

    <!-- Caixa ABERTO ──────────────────────────────────────────────────── -->
    <section v-if="caixaAberto" class="caixa-dropdown__body">
      <div class="caixa-dropdown__row">
        <span class="caixa-dropdown__label">Operador</span>
        <span class="caixa-dropdown__value">{{ operadorNome || '—' }}</span>
      </div>
      <div class="caixa-dropdown__row">
        <span class="caixa-dropdown__label">Terminal</span>
        <span class="caixa-dropdown__value">{{ terminalNome || '—' }}</span>
      </div>
      <div class="caixa-dropdown__row">
        <span class="caixa-dropdown__label">Aberto em</span>
        <span class="caixa-dropdown__value">{{ formatarData(caixaAberto.data_abertura) }}</span>
      </div>
      <div class="caixa-dropdown__row">
        <span class="caixa-dropdown__label">Valor de abertura</span>
        <span class="caixa-dropdown__value">{{ formatBRL(caixaAberto.valor_abertura) }}</span>
      </div>

      <div class="caixa-dropdown__divider"></div>

      <div class="caixa-dropdown__row caixa-dropdown__row--strong">
        <span class="caixa-dropdown__label">Total vendido</span>
        <span class="caixa-dropdown__value">{{ formatBRL(_get('total_vendas')) }}</span>
      </div>
      <div class="caixa-dropdown__row">
        <span class="caixa-dropdown__label">Total dinheiro</span>
        <span class="caixa-dropdown__value">{{ formatBRL(_get('total_dinheiro')) }}</span>
      </div>

      <template v-if="formasVendaList.length">
        <div class="caixa-dropdown__row caixa-dropdown__row--sub" v-for="f in formasVendaList" :key="f.forma">
          <span class="caixa-dropdown__label">{{ f.forma }}</span>
          <span class="caixa-dropdown__value">{{ formatBRL(f.valor) }}</span>
        </div>
      </template>

      <div class="caixa-dropdown__divider"></div>

      <div class="caixa-dropdown__row">
        <span class="caixa-dropdown__label">Suprimentos</span>
        <span class="caixa-dropdown__value">{{ formatBRL(_get('suprimentos')) }}</span>
      </div>
      <div class="caixa-dropdown__row">
        <span class="caixa-dropdown__label">Sangrias</span>
        <span class="caixa-dropdown__value">{{ formatBRL(_get('sangrias')) }}</span>
      </div>

      <div class="caixa-dropdown__divider"></div>

      <div class="caixa-dropdown__row caixa-dropdown__row--strong">
        <span class="caixa-dropdown__label">Dinheiro esperado em caixa</span>
        <span class="caixa-dropdown__value">{{ formatBRL(_get('valor_esperado')) }}</span>
      </div>

      <p v-if="pendentesSync > 0" class="caixa-dropdown__alert">
        <i class="fas fa-cloud-upload-alt"></i>
        Existem movimentações de caixa pendentes de sincronização ({{ pendentesSync }}).
      </p>
    </section>

    <!-- Caixa FECHADO ─────────────────────────────────────────────────── -->
    <section v-else class="caixa-dropdown__body">
      <p class="caixa-dropdown__empty">
        <i class="fas fa-lock"></i>
        Nenhum caixa aberto neste terminal.
      </p>
      <p class="caixa-dropdown__hint">
        Abra um caixa para iniciar as vendas.
      </p>
    </section>

    <!-- Ações ─────────────────────────────────────────────────────────── -->
    <footer class="caixa-dropdown__actions">
      <template v-if="caixaAberto">
        <button class="caixa-dropdown__action" @click="$emit('sangria')">
          <i class="fas fa-arrow-up"></i> Sangria
        </button>
        <button class="caixa-dropdown__action" @click="$emit('suprimento')">
          <i class="fas fa-arrow-down"></i> Suprimento
        </button>
        <button class="caixa-dropdown__action" @click="$emit('resumo-completo')">
          <i class="fas fa-list-alt"></i> Comprovantes / Resumo
        </button>
        <button
          class="caixa-dropdown__action"
          :disabled="sincronizando || !online"
          :title="!online ? 'Sem conexão — não é possível sincronizar agora' : ''"
          @click="$emit('sincronizar')"
        >
          <i class="fas fa-sync" :class="{ 'fa-spin': sincronizando }"></i>
          {{ sincronizando ? 'Sincronizando…' : !online ? 'Sincronizar (offline)' : 'Sincronizar caixa' }}
        </button>
        <button
          class="caixa-dropdown__action"
          :disabled="sincronizando || !online"
          :title="!online ? 'Sem conexão — não é possível recarregar agora' : 'Recarrega todas as combinações/variações do servidor'"
          @click="$emit('recarregar-combinacoes')"
        >
          <i class="fas fa-layer-group"></i>
          Recarregar combinações
        </button>
        <button
          class="caixa-dropdown__action caixa-dropdown__action--danger"
          @click="$emit('fechar-caixa')"
        >
          <i class="fas fa-lock"></i> Fechar caixa
        </button>
      </template>
      <template v-else>
        <button
          class="caixa-dropdown__action caixa-dropdown__action--success"
          @click="$emit('abrir-caixa')"
        >
          <i class="fas fa-lock-open"></i> Abrir caixa
        </button>
        <button class="caixa-dropdown__action" @click="$emit('resumo-completo')">
          <i class="fas fa-history"></i> Ver caixas anteriores
        </button>
      </template>
    </footer>
  </div>
</template>

<script>
export default {
  name: "CaixaResumoDropdown",

  props: {
    caixaAberto:   { type: Object,  default: null },
    resumo:        { type: Object,  default: null },
    operadorNome:  { type: String,  default: "" },
    terminalNome:  { type: String,  default: "" },
    pendentesSync: { type: Number,  default: 0 },
    sincronizando: { type: Boolean, default: false },
    online:        { type: Boolean, default: true },
  },

  computed: {
    formasVendaList() {
      const vpf = this.resumo && this.resumo.vendas_por_forma;
      if (!vpf) return [];
      return Object.keys(vpf)
        .map((k) => ({ forma: k, valor: Number(vpf[k]) || 0 }))
        .filter((f) => f.valor > 0)
        .sort((a, b) => b.valor - a.valor);
    },
  },

  methods: {
    formatBRL(v) {
      const n = Number(v) || 0;
      return n.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
    },
    formatarData(iso) {
      if (!iso) return "—";
      const d = new Date(iso);
      return Number.isNaN(d.getTime())
        ? iso
        : d.toLocaleString("pt-BR", { dateStyle: "short", timeStyle: "short" });
    },
    _get(k) {
      return (this.resumo && Number(this.resumo[k])) || 0;
    },
  },
};
</script>

<style scoped>
.caixa-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  width: 360px;
  max-height: calc(100vh - 80px);
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.18);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  z-index: 1000;
  font-size: 0.85rem;
  color: #1f2937;
}

.caixa-dropdown__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  border-bottom: 1px solid #e5e7eb;
  background: #f9fafb;
}

.caixa-dropdown__title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 700;
  color: #111827;
}

.caixa-dropdown__badge {
  font-size: 0.7rem;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 999px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}
.caixa-dropdown__badge--aberto  { background: #d1fae5; color: #065f46; }
.caixa-dropdown__badge--fechado { background: #fee2e2; color: #991b1b; }

.caixa-dropdown__close {
  background: transparent;
  border: 0;
  color: #6b7280;
  font-size: 1rem;
  cursor: pointer;
  padding: 4px 6px;
  border-radius: 4px;
}
.caixa-dropdown__close:hover { background: #f3f4f6; color: #111827; }

.caixa-dropdown__body {
  padding: 10px 14px;
  overflow-y: auto;
  flex: 1;
}

.caixa-dropdown__row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  padding: 4px 0;
}
.caixa-dropdown__row--strong { font-weight: 700; }
.caixa-dropdown__row--sub {
  padding-left: 12px;
  font-size: 0.78rem;
  color: #4b5563;
}
.caixa-dropdown__label { color: #6b7280; }
.caixa-dropdown__value { color: #111827; font-variant-numeric: tabular-nums; }

.caixa-dropdown__divider {
  height: 1px;
  background: #e5e7eb;
  margin: 8px 0;
}

.caixa-dropdown__alert {
  margin-top: 10px;
  padding: 8px 10px;
  border-radius: 6px;
  background: #fef3c7;
  color: #92400e;
  font-size: 0.78rem;
  display: flex;
  align-items: center;
  gap: 6px;
}

.caixa-dropdown__empty {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #991b1b;
  font-weight: 600;
  margin: 0;
  padding: 6px 0;
}
.caixa-dropdown__hint {
  color: #6b7280;
  font-size: 0.8rem;
  margin: 4px 0 0;
}

.caixa-dropdown__actions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px;
  padding: 10px 14px;
  border-top: 1px solid #e5e7eb;
  background: #f9fafb;
}

.caixa-dropdown__action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 10px;
  border-radius: 6px;
  border: 1px solid #d1d5db;
  background: #fff;
  color: #1f2937;
  font-weight: 600;
  font-size: 0.8rem;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
}
.caixa-dropdown__action:hover { background: #f3f4f6; }
.caixa-dropdown__action:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.caixa-dropdown__action--success {
  background: #047857;
  border-color: #047857;
  color: #fff;
  grid-column: span 2;
}
.caixa-dropdown__action--success:hover { background: #065f46; }
.caixa-dropdown__action--danger {
  background: #b91c1c;
  border-color: #b91c1c;
  color: #fff;
  grid-column: span 2;
}
.caixa-dropdown__action--danger:hover { background: #991b1b; }
</style>
